import { COLORS } from '../../assets/theme/colors'

export const PerpetratorStyle = () => ({
  label: {
    width: '100%',
    paddingLeft: '5px',
    textAlign: 'left' as const,
    color: COLORS.darkerGray
  },
  labeledText: {
    height: '32px',
    width: '300px',
    textAlign: 'left' as const,
    paddingLeft: '10px',
    lineHeight: '32px'
  },
  row: {
    width: '100%'
  },
  topRow: {
    width: '100%',
    paddingRight: '8px'
  },
  messageBar: {
    root: {
      width: '100%',
      maxWidth: '940px'
    }
  },
  datePicker: {
    marginBottom: '-5px',
    width: '300px'
  }
})
